export default __webpack_public_path__ + "5926a35ca358ef8ccdadd7d61efa8ec5.jpg";